import { render, staticRenderFns } from "./todo-list.vue?vue&type=template&id=f8f4bddc&scoped=true"
import script from "./todo-list.vue?vue&type=script&lang=js"
export * from "./todo-list.vue?vue&type=script&lang=js"
import style0 from "./todo-list.vue?vue&type=style&index=0&id=f8f4bddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f4bddc",
  null
  
)

export default component.exports